import styled from 'styled-components';

import { Text12, Text16SB } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const DashboardsEmptyStyled = styled.div`
  display: flex;
  flex-flow: column;
  gap: 8px;
  align-items: center;
  margin: auto 12px;
`;

export const Title = styled(Text16SB)`
  text-align: center;
  color: ${ct({ Dark: Colors.Light, Light: Colors.Light })};
`;

export const Description = styled(Text12)`
  text-align: center;
  color: ${ct({ Dark: Colors.Grey, Light: Colors.Grey })};
`;
